import React from 'react';

import { useTranslation } from 'react-i18next';

import {
  FOHButton,
  FOHView,
  FOHSpaceLarger,
  FOHHeaderH2,
  FOHSmallDetailLabel,
  FOHFonts,
  FOHButtonBordered,
  FOHCautionIcon,
  FOHColors,
  FOHSpaceSmall
} from '../../../components';

import { withReactiveModal, WithReactiveModalProps } from '../../Navigation';

interface NotHiringConfirmationWarningModalProps
  extends WithReactiveModalProps {
  onPressDontCancel: () => void;
  onPressCancelSub: () => void;
}

const NotHiringConfirmationWarningModal: React.FC<
  NotHiringConfirmationWarningModalProps
> = ({ onPressDontCancel, onPressCancelSub }) => {
  const { t } = useTranslation('MyPositionsFeature');

  return (
    <FOHView
      style={{ alignItems: 'center', padding: 24 }}
      testID="NotHiringConfirmationWarningModal"
    >
      <FOHView
        style={{
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        <FOHCautionIcon
          style={{
            width: 40,
            height: 40,
            tintColor: FOHColors.YELLOW_300
          }}
        />
        <FOHSpaceSmall />
        <FOHHeaderH2>{t('notPostedHeader')}</FOHHeaderH2>
      </FOHView>
      <FOHSpaceLarger />
      <FOHView style={{ paddingHorizontal: 110 }}>
        <FOHSmallDetailLabel
          style={{
            textAlign: 'justify',
            fontFamily: FOHFonts.MEDIUM
          }}
        >
          {t('notPostedDescription')}
        </FOHSmallDetailLabel>
        <FOHSpaceLarger />
        <FOHSmallDetailLabel
          style={{ textAlign: 'justify', fontFamily: FOHFonts.BOLD }}
        >
          {t('cancelSubscriptionDescription')}
        </FOHSmallDetailLabel>
      </FOHView>
      <FOHSpaceLarger />
      <FOHView
        style={{
          width: '68%',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <FOHButton
          onPress={onPressCancelSub}
          style={{ maxWidth: 176, width: '100%' }}
          title={t('cancelSubNow')}
        />
        <FOHButtonBordered
          onPress={onPressDontCancel}
          style={{ maxWidth: 176, width: '100%' }}
          title={t('doNotCancelSub')}
        />
      </FOHView>
      <FOHSpaceLarger />
    </FOHView>
  );
};

export default withReactiveModal(NotHiringConfirmationWarningModal);
